<template>
    <transition name="el-fade-in">
        <div class="all" v-show="show">
            <div class="title">{{ name || "Text management" }}</div>
            <div class="btns"></div>
            <page-editer
                :modelData.sync="data"
                :render="renderData"
                :handlerSave="Save"
                :handlerDelete="Delete"
                :handleLoad="Loaded"
                :hideBtn="true"
            ></page-editer>
        </div>
    </transition>
</template>

<script>
export default {
    data() {
        return {
            name: "",
            show: false,
            renderData: [
                {
                    key: "What is face yoga",
                    type: "richText",
                    modelName: "introduction",
                    handleSave: this.Save,
                    must: true,
                },
                {
                    key: "Daily routine",
                    type: "renderList",
                    modelName: "resultText",
                    handleSave: this.RichTextSave,
                    must: true,
                    placeholder:
                        " xxxxxxxxxxx\n xxxxxxxxxxxxx\n xxxxxxxxxxxxxx",
                    format: "回车换行新建行数据",
                },
            ],
            data: {
                name: "",
                description: "",
            },
        };
    },
    methods: {
        Save() {
            let uploadData = this.$deepCopy(this.data);
            this.renderData.some((item) => {
                // 多选数组转字符串数组
                if (item.type === "selects" && this.data[item.modelName]) {
                    uploadData[item.modelName] = this.data[item.modelName].toString();
                }
            });
            this.$request(
                "/manage/intro/save",
                uploadData,
                (res) => {
                    if (res.data.code === 200) {
                        this.$message({
                            message: "save success",
                            type: "success",
                        });
                    }
                },
                "post",
                true
            );
        },
        RichTextSave() {
            let uploadData = this.$deepCopy(this.data);
            this.renderData.some((item) => {
                // 多选数组转字符串数组
                if (item.type === "selects" && this.data[item.modelName]) {
                    uploadData[item.modelName] = this.data[item.modelName].toString();
                }
            });
            {
                // 去掉 resultText 的空字符 和trim验证
                let array = [];
                uploadData.resultText.split("\n").some((item) => {
                    if (item) {
                        array.push(item.trim());
                    }
                });
                uploadData.resultText = array.join("\n");
                console.log(uploadData.resultText);
            }
            if (!uploadData.resultText.trim()) {
                this.$message({ message: "Can not be empty", type: "warning" });
                return true;
            }
            this.$request(
                "/manage/daily/save",
                uploadData,
                (res) => {
                    if (res.data.code === 200) {
                        this.$message({
                            message: "save success",
                            type: "success",
                        });
                        this.$request(
                            `/manage/daily/detail`,
                            {},
                            (res) => {
                                if (res.data.data) {
                                    let data = res.data.data;
                                    this.renderData.some((item) => {
                                        if (
                                            item.type === "selects" &&
                                            data[item.modelName]
                                        ) {
                                            data[item.modelName] =
                                                data[item.modelName].split(",");
                                        }
                                    });
                                    this.data.resultText = data.resultText;
                                }
                            },
                            "get"
                        );
                    }
                },
                "post",
                true
            );
        },
        Delete() {
            // this.$confirm("Confirm delete？", "", { type: "warning" }).then(() => {
            //     this.$request(
            //         "/manage/music/del",
            //         {
            //             idList: [this.$route.query.id],
            //         },
            //         (res) => {
            //             if (res.data.code === 200) {
            //                 this.$message({
            //                     message: "delete success",
            //                     type: "success",
            //                 });
            //                 this.$router.go(-1);
            //             }
            //         }
            //     );
            // });
        },
        getFaceYoga() {},
        Loaded() {
            this.show = true;
            new Promise((resolve) => {
                this.$request(
                    `/manage/intro/detail`,
                    {},
                    (res) => {
                        if (res.data.data) {
                            let data = res.data.data;
                            this.renderData.some((item) => {
                                if (
                                    item.type === "selects" &&
                                    data[item.modelName]
                                ) {
                                    data[item.modelName] =
                                        data[item.modelName].split(",");
                                }
                            });
                            this.data.introduction = data.introduction;
                            resolve();
                        }
                    },
                    "get"
                );
            }).then(() => {
                this.$request(
                    `/manage/daily/detail`,
                    {},
                    (res) => {
                        if (res.data.data) {
                            let data = res.data.data;
                            this.renderData.some((item) => {
                                if (
                                    item.type === "selects" &&
                                    data[item.modelName]
                                ) {
                                    data[item.modelName] =
                                        data[item.modelName].split(",");
                                }
                            });
                            this.data.resultText = data.resultText;
                        }
                    },
                    "get"
                );
            });
        },
    },
};
</script>

<style scoped>
.all {
    box-sizing: border-box;
    padding: 0 40px;
    text-align: left;
    font-size: 13px;
    margin-top: 30px;
}
.title {
    font-size: 24px;
    line-height: 50px;
}
.el-breadcrumb {
    height: 20px;
    line-height: 20px;
    margin-top: 30px;
}
.btns {
    margin: 30px 0;
    height: 20px;
}
/* .kuai-con .el-input >>> input
{
    font-size: 13px;
    height: 27px;
} */
</style>